import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GrUnlock, GrLock } from "react-icons/gr";
import { MdPhoneIphone } from "react-icons/md";
import { LuLaptopMinimalCheck } from "react-icons/lu";
import { FaRegFilePdf, FaUser, FaCalendarAlt, FaShieldAlt } from "react-icons/fa";
import moment from 'moment';
import './Passwords.scss';

export default function PasswordsComponent({ isMobile, mainProps, showSidebar }) {
    const navigate = useNavigate();
    const { main, mainLoading, mainError } = mainProps;
    const [showPasscode, setShowPasscode] = useState(false);
    const [maskedPasscode, setMaskedPasscode] = useState('');

    const passcode = main?.user?.detail?.passcode || "";

    const handleClick = (section) => {
        toast.success(`Modification request for ${section} was sent to the bank representavies, you will get a call for update soon.`);
    }

    useEffect(() => {
        if (showPasscode) {
            setMaskedPasscode(passcode);
        } else {
            const masked = '*'.repeat(passcode.length);
            setMaskedPasscode(masked);
        }
    }, [showPasscode, passcode]);

    return (
        <div
            className="container-fluid bg-col transition-width"
            style={!isMobile ? {
                width: showSidebar ? 'calc(100% - 332px)' : '100%',
                marginLeft: 0,
                marginRight: 'auto',
                transition: showSidebar ? 'width 0.3s ease-in-out' : 'width 0.16s ease-in-out'
            } : {}}
        >
            <div className="row p-3 privacy-consent-panel mb-5">
                <h5 className="mb-5 mt-2">PASSWORDS, PASSCODE, E-Sign</h5>
                <p className="text-muted">
                    In this section, you can view and manage your authentication credentials, including access codes, passwords, and electronic signatures (E-Signs).
                </p>
                <p className="text-muted">
                    For security reasons, any changes to sensitive credentials must be requested through a bank representative and will be carried out under strict verification procedures.
                </p>

                <div className='w-100 mb-5' style={{ border: "2px solid #EFEFEF" }}>
                    <div className='row p-4 align-items-center'>
                        <div className='col-md-4'>
                            <p className="text-muted m-0">PASSCODE</p>
                        </div>
                        <div className='col-md-4 align-items-center' onClick={() => setShowPasscode(!showPasscode)}>
                            {!showPasscode ? <GrUnlock size={20} style={{ color: "#1E266D" }} title='Show Passcode' /> : <GrLock size={20} style={{ color: "#6A343A" }} title='Hide Passcode' />} {maskedPasscode}
                        </div>
                        <div className='col-md-4'>
                            <div className={`${isMobile ? "text-center mt-3" : "text-end mb-0"}`}>
                                <button className='btn rounded-pill balaneCustom-bg-secondary' onClick={() => handleClick('PASSCODE')}>
                                    REQUEST CHANGE
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className='row w-96 m-auto' style={{ borderBottom: "2px solid #EFEFEF" }}></div>

                    <div className='row p-4 align-items-center'>
                        <div className='col-md-4'>
                            <p className="text-muted m-0">Safety Device</p>
                        </div>
                        <div className='col-md-4'>
                            <p className="text-muted m-0"><strong>App Tokens</strong></p>
                        </div>
                        <div className='col-md-4'>
                            {" "}
                        </div>
                    </div>
                </div>

                <h5>DEVICES ASSOCIATED WITH THE APP</h5>

                <div className="table-responsive-custom mb-5">
                    <table className="table table-xxl mt-2 border">
                        <thead>
                            <tr className='table-head py-4'>
                                <th>Device</th>
                                <th className='text-center'>Last Active Date</th>
                                <th className='text-center'>Notifications</th>
                                <th className='text-center'>Disassociates</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    {isMobile ? (
                                        <MdPhoneIphone size={30} style={{ color: "#6A343A" }} />
                                    ) : (
                                        <LuLaptopMinimalCheck size={30} style={{ color: "#6A343A" }} />
                                    )}
                                    <strong>{isMobile ? ' MO' : ' DT'}</strong> (App Tokens)
                                </td>
                                <td className='text-center'>{moment().format("DD/MM/YYYY")}</td>
                                <td className="text-center align-items-center">
                                    <label className="ios-switch ms-2">
                                        <input type="checkbox" checked disabled />
                                        <span className="slider round"></span>
                                    </label>{" "}
                                    On
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h5 className='mb-2'>BLOCK ACCESS TO APP</h5>
                <p className="text-muted mb-0">
                    If you need to block access to your Internet Banking services (website and mobile app) for security reasons, you may do so by clicking the button below.
                </p>
                <p className="text-muted mb-0">
                    Your request will be immediately forwarded to our bank security team to initiate the access restriction procedure.
                </p>
                <p className="text-muted">
                    To restore access, please contact our <strong>official support channels</strong> as listed on the bank’s <a href='https://artesiab.com/contact-us/' target='_blank'>official website</a>.
                </p>

                <div className={`my-3 p-4 ${isMobile ? "text-center" : "text-end"}`}>
                    <button className='btn rounded-pill balaneCustom-bg-secondary' onClick={() => handleClick('BLOCK ACCESS')}>BLOCK ACCESS</button>
                </div>


                <h5 className='my-4'>ONLINE DIGITAL SIGNATURE (E-Sign)</h5>

                <div className='w-100 mb-5 py-3' style={{ border: "2px solid #EFEFEF" }}>
                    <div className='row px-4 py-2 align-items-center'>
                        <div className='col-md-4'>
                            <p className="text-muted m-0">Account holder:</p>
                        </div>
                        <div className='col-md-4' >
                            <p className="text-muted m-0"><strong>{main?.user?.first_name} {main?.user?.last_name}</strong></p>
                        </div>
                        <div className='col-md-4'>
                        </div>
                    </div>

                    <div className='row px-4 py-2 align-items-center'>
                        <div className='col-md-4'>
                            <p className="text-muted m-0">State:</p>
                        </div>
                        <div className='col-md-4' >
                            <p className="text-muted m-0"><strong>INACTIVE</strong></p>
                        </div>
                        <div className='col-md-4'>
                        </div>
                    </div>

                    <div className='row px-4 py-2 align-items-center'>
                        <div className='col-md-4'>
                            <p className="text-muted m-0">Expiration:</p>
                        </div>
                        <div className='col-md-4' >
                        </div>
                        <div className={`col-md-4 ${isMobile && "mt-3"}`}>
                            <FaRegFilePdf size={25} style={{ color: "#6A343A" }} /> <a href='https://artesiab.com/wp-content/uploads/2025/07/EN-eSignature-photos-eSign-documents-using-Adobe-Reader-DC-4.pdf' target='_blank'><strong>E-Sign Operating Manual</strong></a>
                        </div>
                    </div>
                </div>

                {isMobile && (
                    <section className="d-block d-md-none mt-4 px-3 pb-5">
                        <h5 className="text-muted fw-semibold mb-4">You may also need to manage:</h5>
                        <div className="d-grid gap-3">
                            <div
                                onClick={() => navigate("/personal-data")}
                                className="d-flex align-items-center gap-3 p-3 bg-light border rounded-4 shadow-sm cursor-pointer hover-bg"
                            >
                                <FaUser size={25} style={{ color: "#1E266D" }} />
                                <span className="fw-medium text-dark">Personal Data</span>
                            </div>

                            <div
                                onClick={() => navigate("/calendar-appointments")}
                                className="d-flex align-items-center gap-3 p-3 bg-light border rounded-4 shadow-sm cursor-pointer hover-bg"
                            >
                                <FaCalendarAlt size={25} style={{ color: "#1E266D" }} />
                                <span className="fw-medium text-dark">My Calendar</span>
                            </div>

                            <div
                                onClick={() => navigate("/privacy-and-consent")}
                                className="d-flex align-items-center gap-3 p-3 bg-light border rounded-4 shadow-sm cursor-pointer hover-bg"
                            >
                                <FaShieldAlt size={25} style={{ color: "#1E266D" }} />
                                <span className="fw-medium text-dark">Privacy and Consent</span>
                            </div>
                        </div>
                    </section>
                )}

            </div>
        </div >
    );
}